import { Button } from "primereact/button"
import { Tooltip } from "primereact/tooltip"
import { FC, useContext, useEffect, useState } from "react"
import { AiFillDelete } from "react-icons/ai"
import { FaTrashRestore } from "react-icons/fa"
import { GiShieldDisabled } from "react-icons/gi"
import { getHomeInfo } from "../../services/home-service"
import { catchResponse } from "../../utils/helperFunctions"
import { error, success, warning } from "../../utils/notifications"
import './scenariorecovery.css'
import { Dropdown } from 'primereact/dropdown';
import { ScenarioRecoveryTable } from "./ScenarioRecoveryTable/ScenarioRecoveryTable"
import { useHistory, useParams } from "react-router-dom"
import { Spinner } from "../shared/Spinner/Spinner"
import { MdOutlineKeyboardBackspace } from "react-icons/md"
import { deleteScenarios, disableScenarios, getAllScenariosById, restoreScenarios } from "../../services/scenario-recovery-service"
import { FiCommand } from "react-icons/fi"
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup"
import { UserContext } from "../../Redux/UserContext"



export const ScenarioRecovery:FC<any> = () => {

    const {id}:any = useParams()

    const [state] = useContext(UserContext)

    const history:any = useHistory()

    const [scenarios, setScenarios] = useState<any[]>([])

    const [loadingInfo, setLoadingInfo] = useState<boolean>(false)

    const [loadingActionRest, setLoadingActionRest] = useState<boolean>(false)
    const [loadingActionDesact, setLoadingActionDesact] = useState<boolean>(false)
    const [loadingActionDelete, setLoadingActionDelete] = useState<boolean>(false)

    const [scenarioFlag, setScenarioFlag] = useState<boolean>(false)

    const [selectedRows, setSelectedRows] = useState<number[]>([])

    const [disabledRestaurar, setDisabledRestaurar] = useState<boolean>(true)

    const [disabledDesactivar, setDisabledDesactivar] = useState<boolean>(true)

    const [disabledEliminar, setDisabledEliminar] = useState<boolean>(true)

    const [plantas, setPlantas] = useState<any[]>([])

    const [selectedPlant, setSelectedPlant] = useState<number>(parseInt(id));

    const accept = async() => {
        try {
            setLoadingActionDelete(true)
            const res = await deleteScenarios(selectedRows)
            if(res.status === 200) {
                const { message, code } = res.data
                if(code === 200) {
                    success(message)
                    setSelectedRows([])
                    setDisabledRestaurar(true)
                    setDisabledDesactivar(true)
                    setDisabledEliminar(true)
                    setScenarioFlag(!scenarioFlag)
                } else {
                    error(message)
                }
                setLoadingActionDelete(false)
            }
            setLoadingActionDelete(false)
        } catch(err:any) {
            catchResponse(err)
            setLoadingActionDelete(false)
        }
    }

    const reject = () => {
        
    }

    const confirm = (event:any) => {
        
        confirmPopup({
            target: event.target,
            message: 'Se borrarán permanentemente estos escenarios. ¿Estás seguro?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Si',
            rejectLabel:'No',
            accept,
            reject
        });
    };

    const handleChangePlant = (e:any) => {
        setSelectedRows([])
        setSelectedPlant(e.value)
        history.push(`/home/${e.value}`)
    }

    const fetchAllScenariosByPlantId = async() => {
        try {
            setLoadingInfo(true)
            const res = await getAllScenariosById(id)
            if(res.status === 200) {
                const { code, data, message } = res.data
                if(code !== 200) {
                    error(message)
                    setLoadingInfo(false)
                } else {
                    setScenarios(data)
                    setLoadingInfo(false)
                }
            }
            setLoadingInfo(false)
        } catch(err:any) {
            catchResponse(err)
            setLoadingInfo(false)
        }
    }

    const fetchHomeInfo = async () => {
        try {
            setLoadingInfo(true)
            const res = await getHomeInfo()
            const { status } = res
            if(status === 200) {
                const { code,data } = res.data
                if(code === 200) {
                    let estrategico = data.filter((d:any) => d.id_planner === 1)
                    let estrategico_structure = {
                        label: 'Estratégico',
                        code: 1,
                        items: estrategico.map((es:any) => ({label:es.name_plant,value: es.id_plant,disabled: !state?.id_plants.includes(es.id_plant)}))
                    }
                    let operativo = data.filter((d:any) => d.id_planner !== 1)
                    let operativo_structure = {
                        label: 'Operativo',
                        code: 2,
                        items: operativo.map((op:any) => ({label:op.name_plant,value: op.id_plant}))
                    }
                    let aux = [estrategico_structure,operativo_structure]
                  
                    setPlantas(aux)
                } 
                setLoadingInfo(false)
            }

        } catch(err:any) {
            console.log(err)
            error("Error obteniendo la información")
            setLoadingInfo(false)
        }
    }

    const handleRestore = async() => {
        try {
            setLoadingActionRest(true)
            const res = await restoreScenarios(selectedRows)
            if(res.status === 200) {
                const { code, message } = res.data
                if(code === 200) {
                    success(message)
                    setSelectedRows([])
                    setScenarioFlag(!scenarioFlag)
                } else if(code === 501) {
                    warning(message)
                } else {
                    error(message)
                }   
                setLoadingActionRest(false)
            }
            setLoadingActionRest(false)
        } catch(err:any) {
            setLoadingActionRest(false)
            catchResponse(err)
        }
    }

    const handleDisable = async() => {
        try {
            setLoadingActionDesact(true)
            const res = await disableScenarios(selectedRows)
            if(res.status === 200) {
                const { code, message } = res.data
                if(code === 200) {
                    success(message)
                    setSelectedRows([])
                    setScenarioFlag(!scenarioFlag)
                } else if(code === 501) {
                    warning(message)
                } else {
                    error(message)
                }
                setLoadingActionDesact(false)   
            }
            setLoadingActionDesact(false)
        } catch(err:any) {
            setLoadingActionDesact(false)
            catchResponse(err)
        }
    }


    useEffect(() => {
        fetchHomeInfo()
        fetchAllScenariosByPlantId()
    },[scenarioFlag,selectedPlant])

    return (
        <div className="admin__wrapper">
            <div className="scenario-recovery-content">
                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <ConfirmPopup />
                    <Tooltip target={".home-back"} position="bottom" style={{fontSize:'0.75rem'}}>
                        Volver
                    </Tooltip>
                    <MdOutlineKeyboardBackspace className="home-back"  size={30} style={{marginRight:'1rem',cursor:'pointer'}} onClick={() => history.push("/home")} />
                    <Dropdown  style={{minWidth:285}} value={selectedPlant} onChange={handleChangePlant} options={plantas} optionLabel="label" optionGroupLabel="label" optionGroupChildren="items"  className="w-full md:w-14rem dropdown-plants" placeholder="Selecciona una planta" />
                    <span style={{fontSize:'0.9rem',marginLeft:'1rem'}}>(<i style={{fontSize:'0.75rem'}}>Últimos 30 días</i>)</span>
                </div>
                <div className="scenarios-footer" style={{width:'30%'}}>
                    <Button severity={'success'} onClick={handleRestore} style={{fontSize:'0.85rem',minWidth:140}} label="Restaurar" icon={loadingActionRest? <FiCommand className="loading-icon" style={{fontSize:20,color:'#22C55E'}} /> : <FaTrashRestore style={{fontSize:20,marginRight:'0.5rem'}} />} outlined disabled={disabledRestaurar || loadingActionRest || loadingActionDelete || loadingActionDesact || selectedRows.length === 0}   />
                    <Button severity={'secondary'} onClick={handleDisable} style={{fontSize:'0.85rem',minWidth:140}} label="Desactivar" icon={loadingActionDesact? <FiCommand className="loading-icon" style={{fontSize:20,color:'#64748B'}} /> :<GiShieldDisabled style={{fontSize:20,marginRight:'0.5rem'}} />}  outlined disabled={disabledDesactivar || loadingActionRest || loadingActionDelete || loadingActionDesact || selectedRows.length === 0} />
                    <Button severity={'danger'} onClick={(e:any) => confirm(e)} style={{fontSize:'0.85rem',minWidth:140}} label="Eliminar" icon={loadingActionDelete? <FiCommand className="loading-icon" style={{fontSize:20,color:'red'}} /> :<AiFillDelete style={{fontSize:20,marginRight:'0.5rem'}} />} outlined disabled={disabledEliminar || loadingActionRest || loadingActionDelete || loadingActionDesact || selectedRows.length === 0} />
                </div>
            </div>
            {
                loadingInfo?
                <div className="ag-theme-alpine" style={{display:'flex',flexDirection:'column', height:'90%', width: '95%',justifyContent:'center',borderTop:'1px solid #dee2e6',fontSize:'0.85rem' }}>
                    <Spinner message={`Obteniendo información de la planta`} />
                </div>
                
                :
                <ScenarioRecoveryTable
                    data={scenarios} 
                    selectedRows={selectedRows} 
                    setSelectedRows={setSelectedRows} 
                    disabledRestaurar={disabledRestaurar} 
                    setDisabledRestaurar={setDisabledRestaurar}
                    disabledDesactivar={disabledDesactivar}
                    setDisabledDesactivar={setDisabledDesactivar}
                    disabledEliminar={disabledEliminar}
                    setDisabledEliminar={setDisabledEliminar}
                    loading={loadingActionRest || loadingActionDelete || loadingActionDesact}
                    />
 
            }
            
        </div>
    )
}